import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import MachineTable from './machine-table';
import MachineTile from './machine-tile';
import MachineSearch from './machine-search';
import { selectMachineFilterVisible, selectTileView } from './store/selectors'; // Import the selector

const MachineContent = props => {
  const isFilterVisible = useSelector(selectMachineFilterVisible); // Use the selector
  const showTileView = useSelector(selectTileView); // Use the selector

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <MachineSearch />
        </div>
        {/* {isFilterVisible && <MachineFilter />} */}

        {!showTileView ? <MachineTable /> : <MachineTile />}
      </div>
    </div>
  );
};

export default MachineContent;
